import React from 'react';
import { useTranslation } from 'react-i18next';
import { Carousel, CarouselDots } from '@shared/ui';
import { useNoDigitalSchedule } from './useNoDigitalSchedule';
import { NoDigitalCalendarProps, NoDigitalSingleSchedule } from './types';
import { NoDigitalCalendarHeader } from './components/no-digital-calendar-header';
import { NoDigitalCalendarBody } from './components/no-digital-calendar-body';
import iconWarning from '../../assets/images/icon-warning-alt.png';

export const NoDigitalCalendar: React.FC<NoDigitalCalendarProps> = ({
  className = '',
  slots,
  selectedSlot,
  onSlotSelect,
  loading = false,
  error = null,
  errorType = null,
}) => {
  const { t } = useTranslation();
  const schedule = useNoDigitalSchedule(slots);



  if (loading) {
    return (
      <div className={`${className} flex items-center justify-center py-12`}>
        <div className="flex flex-col items-center space-y-3">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#004039]"></div>
          <p className="text-gray-600">Cargando horarios presenciales...</p>
        </div>
      </div>
    );
  }

  if (error) {
    const getErrorMessage = () => {
      let messageKey = '';
      
      if (errorType === 'slots') {
        messageKey = 'common.noDigitalErrors.slotsError.message';
      } else if (errorType === 'assign_slots') {
        messageKey = 'common.noDigitalErrors.assignSlotsError.message';
      } else if (errorType === 'existing_appointment') {
        messageKey = 'common.noDigitalErrors.existingAppointmentError.message';
      } else {
        messageKey = 'common.noDigitalErrors.genericError.message';
      }

      return (
        <>
        
          <h3 
            className="text-lg font-medium text-gray-900 mb-1"
            dangerouslySetInnerHTML={{ __html: t(messageKey) }}
          />
        </>
      );
    };

    return (
      <div className={`${className} flex items-center justify-center py-12`}>
        <div className="text-center">
          <div className="mb-2">
            <img src={iconWarning} alt="Warning" className="mx-auto h-12 w-12" />
          </div>
          {getErrorMessage()}
        </div>
      </div>
    );
  }

  if (!schedule.length) {
    return (
      <div className={`${className} flex items-center justify-center py-12`}>
        <div className="text-center">
          <div className="text-gray-400 mb-2">
            <svg className="mx-auto h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-1">No hay horarios disponibles</h3>
          <p className="text-gray-600">No se encontraron horarios presenciales disponibles para esta póliza</p>
        </div>
      </div>
    );
  }

  return (
    <div className={className}>
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Horarios para citas presenciales
        </h3>
        <p className="text-sm text-gray-600">
          Selecciona el día y la hora para la cita presencial con el referente social.
        </p>
      </div>
      
      <Carousel DotsComponent={CarouselDots}>
        {schedule.map((slider: NoDigitalSingleSchedule, index: number) => (
          <div key={`no-digital-calendar-${index}`}>
            <table className="w-full border-collapse">
              <NoDigitalCalendarHeader header={slider} />
              <NoDigitalCalendarBody
                content={slider}
                selectedSlot={selectedSlot}
                onSlotSelect={onSlotSelect}
              />
            </table>
          </div>
        ))}
      </Carousel>
      

    </div>
  );
};